module.exports = __webpack_public_path__ + "img/63.99d655ab.jpg";